import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
const ProductSheetDocuments = ({ documents, title }) => {
  const selectedDocuments = useSelector((state) => state.documents);
  let docArr;
  if (
    selectedDocuments?.documents &&
    selectedDocuments.documents.length > 0
  ) {
    docArr = JSON.parse(selectedDocuments.documents);
  } else {
    docArr = JSON.parse(documents);
  }
  if (!docArr) docArr = false;
  const setSelected = (event) => {
    event.currentTarget.parentNode.classList.toggle('expanded');
  };
  return (
    docArr &&
    docArr.length > 0 && (
      <div className="small-12 large-12 columns product-about">
        <h3 className="product-about__block-title">{title}</h3>
        <div className="product-about__accordion">
          <div
            className="product-about__heading-container">
            <div className="product-about__heading" onClick={(e) => setSelected(e)}>
              <h6 className="product-about__title">{translate('product.documents.title')}</h6>
              <div className="product-about__icon"></div>
            </div>
            <div className="product-about__content">
              <div className="product-about__documents">
                {docArr.map((doc, indexInner) => (
                  <div
                    key={indexInner}
                    className="product-about__specifications product-about__specifications--full-width"
                  >
                    <a href={doc.url} target="_blank" className="order-detail__product-link">
                      <div className="product-about__specifications-item product-about__specifications-item--document">
                        <div className="product-about__download-icon"></div>{doc.name}
                      </div></a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ProductSheetDocuments;
